import { Navigate, Outlet, Route, Routes } from 'react-router';
import { Gate } from './Gate';
import { ChangePassword } from './screens/ChangePassword/ChangePassword';
import { ComingSoon } from './screens/ComingSoon/ComingSoon';
import { EventPage } from './screens/Events/EventPage';
import { EventsTab, Past, Upcoming } from './screens/Events/Events';
import { Month } from './screens/Events/Month';
import { Home } from './screens/Home/Home';
import { Login } from './screens/Login/Login';
import { Member } from './screens/Members/Member';
import { Members } from './screens/Members/Members';
import { NewMember } from './screens/Members/NewMember';
import { Profile } from './screens/Profile/Profile';
import { ProfilePassword } from './screens/Profile/ProfilePassword';
import { SessionProvider } from './session';
import { Shell } from './Shell';

/**
 * The app: the session, and the routes (ARCHITECTURE → The web app's structure; D22). main.tsx
 * puts it in the browser's router; the tests in a MemoryRouter. The shell's routes match its
 * tabs (Shell.tsx → NAV); a step that builds a screen replaces its ComingSoon here, and a tab's
 * own screens go under its path (/profile/password, /events/:id). The Events tab's three views are
 * routes under its frame (B3; D34): /events, /events/past and /events/month, whose static names
 * rank above an event's id. Every route under /admin is an admin's: the guard around their outlet
 * sends anyone else to Home (D25).
 */
export function App() {
  return (
    <SessionProvider>
      <Routes>
        <Route
          path="/login"
          element={
            <Gate need="signedOut">
              <Login />
            </Gate>
          }
        />
        <Route
          path="/change-password"
          element={
            <Gate need="mustChange">
              <ChangePassword />
            </Gate>
          }
        />
        <Route
          element={
            <Gate need="signedIn">
              <Shell />
            </Gate>
          }
        >
          <Route index element={<Home />} />
          <Route path="events" element={<EventsTab />}>
            <Route index element={<Upcoming />} />
            <Route path="past" element={<Past />} />
            <Route path="month" element={<Month />} />
          </Route>
          <Route path="events/:id" element={<EventPage />} />
          <Route path="boards" element={<ComingSoon title="nav.boards" />} />
          <Route path="profile" element={<Profile />} />
          <Route path="profile/password" element={<ProfilePassword />} />
          <Route
            path="admin"
            element={
              <Gate need="admin">
                <Outlet />
              </Gate>
            }
          >
            <Route index element={<Navigate to="/admin/members" replace />} />
            <Route path="members" element={<Members />} />
            <Route path="members/new" element={<NewMember />} />
            <Route path="members/:id" element={<Member />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </SessionProvider>
  );
}
